import {Button, Col, Modal, Tooltip} from 'antd';
import React from 'react';

interface RemoveRedundantLegButtonProps {
    compact?: boolean;
    emptyReturn?: boolean;
    originOnly?: boolean;
    disabled?: boolean;
    readOnly?: boolean;
    onRemove?: () => void | Promise<void>;
}

/**
 * Shared removal action for a route stop that FlightLegManager has confirmed
 * can be skipped without dropping any PAX/CGO movement, or an empty return leg.
 */
const RemoveRedundantLegButton: React.FC<RemoveRedundantLegButtonProps> = ({
    compact,
    emptyReturn,
    originOnly,
    disabled,
    readOnly,
    onRemove
}) => {
    if (!onRemove || readOnly) return null;

    const action = (
        <Tooltip title={disabled
            ? 'An operation is in progress.'
            : originOnly
                ? 'Remove this empty origin-to-origin leg.'
                : emptyReturn
                ? 'Remove the empty return leg to make this a one-way trip.'
                : 'This stop can be skipped without dropping any PAX/CGO movement. Remove this redundant leg.'}
        >
            <Button
                type="danger"
                size={compact ? 'small' : undefined}
                icon={compact ? 'delete' : undefined}
                aria-label={compact ? (originOnly ? 'Remove origin-only leg' : emptyReturn ? 'Remove empty return leg' : 'Remove redundant leg') : undefined}
                disabled={disabled}
                onMouseDown={(event) => event.stopPropagation()}
                onClick={(event) => {
                    event.stopPropagation();
                    Modal.confirm({
                        title: originOnly
                            ? 'Remove this empty origin-to-origin leg? The flight will have no route.'
                            : emptyReturn
                            ? 'Remove the empty return leg and make this a one-way trip?'
                            : 'Are you sure you want to remove this redundant leg?',
                        onOk: onRemove,
                        okButtonProps: {
                            children: 'Remove',
                            type: 'danger'
                        }
                    });
                }}
            >
                {compact ? null : (originOnly ? 'Remove Origin-only Leg' : emptyReturn ? 'Remove Empty Return Leg' : 'Remove Redundant Leg')}
            </Button>
        </Tooltip>
    );

    return compact ? action : <Col>{action}</Col>;
};

export default RemoveRedundantLegButton;
